/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: { size: { type: 'variant', values: [ 'small' ] } },
  rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 4 } } ],
  tokens: { fullScreenOverLayBackground: '#9c9faa', size: 48, thickness: 4 }
}
export default theme
